import React, { useEffect, useRef } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { TweenLite } from 'gsap';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import MathUtil from 'src/util/MathUtil';
import ContractGenerationTractDetail from './redesign/ContractGenerationModels/ContractGenerationTractDetail';
import AgreementUtil from 'src/util/AgreementUtil';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import ContractGenerationOwnerData from './redesign/ContractGenerationModels/ContractGenerationOwnerData';

interface ILeasingTractListProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    totalGross: number;
    totalNet: number;
    tracts: Array<ContractGenerationTractDetail>;
    originalTractList: Array<ContractGenerationTractDetail>;
    inHand?: boolean;
    parentTractType: string;
    isEasternStates: boolean;
    tractLimit: string[];
    clientNumber: number;
    projectNumber: number;
    ownerData?: ContractGenerationOwnerData;

    includeTract: () => void;
}

const LeasingTractList = (props: ILeasingTractListProps) => {
    const dispatch = useDispatch();
    const legDescEl = useRef([]);

    useEffect(() => {
        if (props.tracts?.length > 0) {
            console.log('Lease Tracts:', props.tracts);
        }
    }, [props.tracts]);

    const handleLeaseTractNavigation = (tract: ContractGenerationTractDetail) => {
        let tractTypeId = 0;
        if (props.parentTractType === 'Mineral Tract') {
            tractTypeId = 1;
        } else if (props.parentTractType === 'Surface Tract') {
            tractTypeId = 2;
        }

        dispatch(push(AgreementUtil.navigateToTract(tract, tractTypeId, props.clientNumber, props.projectNumber)));
    };

    const toggleLegalDesc = (state: boolean, index: number, clientX: number, clientY: number) => {
        if (state) {
            TweenLite.set(
                legDescEl.current[index],
                { top: `${clientY - 10}`, left: `${clientX + 10}`, height: 'auto', display: 'inline-block', background: 'white', border: '2px solid #6393C1', zIndex: 100 }
            );
        } else {
            TweenLite.to(legDescEl.current[index], 0.2, { height: '2.5rem', display: 'none', background: 'transparent', borderColor: 'transparent', zIndex: 0 });
        }
    };

    return (
        <div>
            <div style={{ display: 'flex' }}>
                <div style={{ width: '5%' }}>
                    <span className="column-heading">Include</span>
                </div>
                <div style={{ width: '8%' }}>
                    <span className="column-heading">Global ID</span>
                </div>
                <div style={{ width: '10%' }}>
                    <span className="column-heading">Name</span>
                </div>
                <div style={{ width: '5%' }}>
                    <span className="column-heading">Type</span>
                </div>
                <div style={{ width: '10%' }}>
                    <span className="column-heading">Sec/Twp/Rng</span>
                </div>
                <div style={{ width: '8%' }}>
                    <span className="column-heading">County</span>
                </div>
                <div style={{ width: '10%' }}>
                    <span className="column-heading">Legal Description</span>
                </div>

                <div style={{ width: '8%' }}>
                    <span className="column-heading">Gross</span>
                </div>
                <div style={{ width: '8%' }}>
                    <span className="column-heading">Net</span>
                </div>
                <div style={{ width: '13%' }}>
                    <span className="column-heading">Interest</span>
                </div>
                <div style={{ width: '5%' }}>
                    <span className="column-heading">Lease Status</span>
                </div>
                <div style={{ width: '10%' }}>
                    <span className="column-heading">Ownership Type</span>
                </div>
                <div style={{ width: '3%' }}>
                    <span className="column-heading">SSP</span>
                </div>
            </div>

            <div>
                {props?.tracts?.length > 0 &&
                    props.tracts.map((field, index) => {
                        let notIncluded = (field.leasedStatus === 'Leased')
                            || props.inHand 
                            || (props.tractLimit.indexOf(field.type) === -1);
                        let classes = ['', '', '', '', '', ''];
                        let originTract = props.originalTractList.find(ot => ot.ownershipId === field.ownershipId);
                        if (!!originTract) {
                            let originNet = MathUtil.cleanNumber((originTract.grossAcres * originTract.decimalInterest), 7);
                            let fieldNet = MathUtil.cleanNumber((field.grossAcres * field.decimalInterest), 7);

                            if ((!originTract.county && !!field.county) || (!!originTract.county && !field.county) || originTract.county?.name !== field.county?.name) {
                                classes[0] = 'yellow';
                            }
                            if (originTract.legalDescription !== field.legalDescription) {
                                classes[1] = 'yellow';
                            }
                            if (originTract.grossAcres !== field.grossAcres) {
                                classes[2] = 'yellow';                            
                            }
                            if (originNet !== fieldNet) {
                                classes[3] = 'yellow';                           
                            }
                            if (originTract.decimalInterest !== field.decimalInterest) {
                                classes[4] = 'yellow';
                            }
                            if (originTract.leasedStatus !== field.leasedStatus) {
                                classes[5] = 'yellow';
                            }
                        } else if (props.originalTractList.length > 0) {
                            classes[6] = 'yellow';
                        }

                        return (
                            <div key={index}>
                                <div key={index} style={{ display: 'flex', borderBottom: '1px solid darkgrey' }} className={classes[6]}>
                                    <div style={{ width: '5%' }}>
                                        <div>
                                            {/* <FormCheckbox name={`${name}.includeTract`} label="" onChange={() => this.onIncludeTractChange()} /> */}
                                            <input type="hidden" name={`tracts[${index}].id`} ref={props.register()} />
                                            <input type="hidden" name={`tracts[${index}].ownershipId`} ref={props.register()} />
                                            <input type="hidden" name={`tracts[${index}].contractLookupId`} ref={props.register()} />
                                            <input type="hidden" name={`tracts[${index}].invoiceableLookupId`} ref={props.register()} />
                                            <RHFCheckbox
                                                name={`tracts[${index}].includeTract`}
                                                label=""
                                                register={props.register}
                                                errors={props.errors}
                                                onClick={props.includeTract}
                                                disabled={notIncluded}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ width: '8%' }} className="clickable text-link">
                                        <span>
                                            <span onClick={() => handleLeaseTractNavigation(field)}>{AgreementUtil.getGlobalId(field, props.parentTractType)}</span>
                                            {/* <FormText name={`${name}.sectionNumber`} /> */}
                                            <input type="hidden" name={`tracts[${index}].sectionNumber`} ref={props.register()} />
                                            <input type="hidden" name={`tracts[${index}].section`} ref={props.register()} />
                                            <input type="hidden" name={`tracts[${index}].tractNumber`} ref={props.register()} />
                                            <input type="hidden" name={`tracts[${index}].surfaceTractNumber`} ref={props.register()} />
                                            <input type="hidden" name={`tracts[${index}].horizonNumber`} ref={props.register()} />
                                        </span>
                                    </div>

                                    <div style={{ width: '10%' }}>
                                        {/* <FormText name={`${name}.tractName`} /> */}
                                        <span>{field.tractName}</span>
                                        <input type="hidden" name={`tracts[${index}].tractName`} ref={props.register()} />
                                    </div>

                                    <div style={{ width: '5%' }}>
                                        {/* <FormText name={`${field}.type`} /> */}
                                        <span>{field.type}</span>
                                        <input type="hidden" name={`tracts[${index}].type`} ref={props.register()} />
                                    </div>

                                    <div style={{ width: '10%' }}>
                                        <span>
                                            {/* <FormText name={`${name}.section`} /> */}
                                            {/* <FormText name={`${name}.easternTownship`} /> */}
                                            {props.isEasternStates && (
                                                <>                                                    
                                                    <span>{field.township}</span>
                                                    <input type="hidden" name={`tracts[${index}].township`} ref={props.register()} />
                                                    <span>/</span>
                                                    <span>{field.sectionNumber}</span>
                                                    <input type="hidden" name={`tracts[${index}].sectionNumber`} ref={props.register()} />
                                                </>
                                            )}
                                            {!props.isEasternStates && (
                                                <>
                                                    <span>{field.township}</span>
                                                    <input type="hidden" name={`tracts[${index}].township`} ref={props.register()} />
                                                    <span>/</span>
                                                    <span>{field.section}</span>
                                                    <input type="hidden" name={`tracts[${index}].sectionNumber`} ref={props.register()} />
                                                    <span>/</span>
                                                    {/* <FormText name={`${name}.range`} /> */}
                                                    <span>{field.range}</span>
                                                    <input type="hidden" name={`tracts[${index}].range`} ref={props.register()} />
                                                </>
                                            )}
                                        </span>
                                    </div>

                                    <div style={{ width: '8%' }} className={classes[0]}>
                                        {/* <FormText name={`${name}.county.name`} /> */}
                                        <span>{field.county?.name}</span>
                                        <input type="hidden" name={`tracts[${index}].countyId`} ref={props.register} />
                                    </div>

                                    <div style={{ width: '10%' }} className={classes[1]}>
                                        {/* <FormText name={`${name}.legalDescription`} /> */}
                                        <div style={{display: 'flex'}}>
                                            <span
                                                style={{fontSize: '20px'}}
                                                onMouseOver={(e) => toggleLegalDesc(true, index, e.clientX, e.clientY)}
                                                onMouseOut={() => toggleLegalDesc(false, index, 0, 0)}
                                            >
                                                👁‍🗨
                                            </span>
                                            <span
                                                style={{ width: '8em', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap' }}
                                            >
                                                {field.legalDescription}
                                            </span>
                                        </div>
                                        <span
                                            ref={el => legDescEl.current[index] = el}
                                            style={{
                                                borderRadius: '5px',
                                                border: '2px solid #6393C1',
                                                display: 'none',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                position: 'absolute',
                                                padding: '.3rem',
                                                background: 'transparent',
                                                borderColor: 'transparent',
                                                zIndex: 10,
                                                height: 'auto',
                                            }}
                                        >
                                        {field.legalDescription}
                                        <input type="hidden" name={`tracts[${index}].legalDescription`} ref={props.register()} />
                                        </span>
                                    </div>

                                    <div style={{ width: '8%' }} className={classes[2]}>
                                        {/* <FormText name={`${name}.grossAcres`} /> */}
                                        <span>{MathUtil.cleanNumber(field.grossAcres, 7)}</span>
                                        <input type="hidden" name={`tracts[${index}].grossAcres`} ref={props.register} />
                                    </div>

                                    <div style={{ width: '8%' }} className={classes[3]}>
                                        {/* <FormText name={`${name}.netAcres`} /> */}
                                        <span>{MathUtil.cleanNumber((field.grossAcres * field.decimalInterest), 7) || 'N/A'}</span>
                                        <input type="hidden" name={`tracts[${index}].netAcres`} ref={props.register} />
                                    </div>

                                    {/* 
                                    ADD NEMI TOOLTIP
                                    <div style={{ width: '1%', marginRight: '1px', position: 'relative' }}>
                                        <Field name={`${name}.hasNEMI`}>
                                            {({ input }) => (
                                                <span
                                                    onMouseEnter={() => this.setState({ showNEMIToolTipIndex: index })}
                                                    onMouseLeave={() => this.setState({ showNEMIToolTipIndex: undefined })}
                                                >
                                                    {input.value ? <i style={{ color: '#6393c1' }} className="fas fa-info-circle clickable" /> : ''}
                                                </span>
                                            )}
                                        </Field>
                                        {this.state.showNEMIToolTipIndex === index &&
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-50%',
                                                    left: '10px',
                                                    zIndex: 9000,
                                                    backgroundColor: '#6393c1',
                                                    color: 'white',
                                                    width: '4rem',
                                                    padding: '.2rem',
                                                    borderRadius: '3px',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                NEMI
                                            </div>
                                        }
                                    </div> */}

                                    <div style={{ width: '13%' }} className={classes[4]}>
                                        {/* <FormText type="number" name={`${name}.decimalInterest`} /> */}
                                        <span>{MathUtil.cleanNumber(field.decimalInterest, 10, 0)}</span>
                                        <input type="hidden" name={`tracts[${index}].decimalInterest`} ref={props.register} />
                                    </div>

                                    <div style={{ width: '5%' }} className={classes[5]}>
                                        {/* <FormText name={`${name}.leasedStatus`} /> */}
                                        <span>{field.leasedStatus}</span>
                                        <input type="hidden" name={`tracts[${index}].leasedStatus`} ref={props.register} />
                                    </div>

                                    <div style={{ width: '10%' }} className={classes[5]}>
                                        {/* <FormText name={`${name}.leasedStatus`} /> */}
                                        <span>{field.additionalOwnershipType}</span>
                                        <input type="hidden" name={`tracts[${index}].additionalOwnershipType`} ref={props.register} />
                                    </div>

                                    <div style={{ width: '3%' }}>{props?.ownerData?.ownerships?.find((ownership) =>
                                        ownership.isCommunityProperty === true
                                        ) ? 'N' : 'Y'}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>

            <div style={{ display: 'flex', marginTop: '1rem' }}>
                <div style={{ width: '66%', textAlign: 'right', paddingRight: '1rem' }}>
                    <span>Total Acreages:</span>
                </div>

                <div style={{ width: '8%' }}>
                    {/* <FormText name="totalGross" /> */}
                    <span>{MathUtil.cleanNumber(props.totalGross, 7)}</span>
                </div>

                <div style={{ width: '5%' }}>
                    {/* <FormText name="totalNet" /> */}
                    <span>{MathUtil.cleanNumber(props.totalNet, 7)}</span>
                </div>

                <div style={{ width: '5%' }}>{/* <FormText name="totalDecimalInterest" /> */}</div>

                <div style={{ width: '5%' }} />
            </div>
        </div>
    );
};

export default LeasingTractList;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LeasingTractList.redesign.tsx